import { Dialog, LoadBar } from "../components/ui";
import i18n from "i18next";
import { getCurrentLang } from "../config/commonUtil";

import urlConstantJs from "../config/ConstantConfig";

// import { setSessionItem } from '@/config/commonUtil';

/*--枚举类型--*/
export const TOKEN = "TOKEN";

var Fly = require("flyio/dist/npm/fly");
let fly = new Fly();
fly.config.timeout = 50000;

const lang = getCurrentLang();
const baseURL = window.location.host;
const originURL = window.location.origin;
// // 根据不同的域名返回不同的环境
fly.config.baseURL = urlConstantJs.baseURL; //已经判断好用uat还是prod的url了
// 根据不同的域名返回不同的环境

// 请求数据量
let fetchCount = 0;

//显示loading
function showLoading() {
  if (fetchCount === 0) {
    LoadBar.show();
  }
  fetchCount = fetchCount + 1;
}
// 隐藏loading
function hideLoading() {
  fetchCount = fetchCount - 1;
  if (fetchCount === 0) {
    LoadBar.hide();
  }
}

//goToHomePage
function goToHomePage(){
  console.log("goToHomePage")
  let proIsNot = process.env.NODE_ENV == "production";
    let url = "";
    if (proIsNot) {
      url = window.location.origin + `/love-yourself-vhis/${lang}/learn-page`;
    } else {
      url = window.location.origin + `/${lang}/learn-page`;
    }
    window.location.href = url;
}

// 请求拦截
fly.interceptors.request.use((request) => { 
  console.log(i18n.t("error:errorMsg.requestFailTitle"),'TITLW');
  // 需要loading下，显示loading
  const customBody = request.body || {};
  const customHeader = customBody.header || {};
  const noLoading = customHeader.noLoading || false;
  if (!noLoading) {
    showLoading();
  }
  let currentToken = sessionStorage.getItem(TOKEN);  
  request.headers.Authorization = currentToken;
  return request;
});
// reponse拦截
fly.interceptors.response.use(
  (response) => {
    // debugger;
    // 有loading下，取消loading
    const customBody = response.request.body || {};
    const customHead = customBody.headers || {};
    const noLoading = customHead.noLoading || false;
    if (!noLoading) {
      hideLoading();
    }
    if (response.headers.newtoken) {
      sessionStorage.setItem(TOKEN, response.headers.newtoken);
    }
    const data = response.data || {};
    const errors = data.errors || [];
    const code = data.code || "";
    const errorMsg = data.message || "";
    if (data.success) {
      return data.data;
    } else {
      if (code == 4) {
        // Dialog({ title: errorMsg, hideCancelBtn: true });
        return data.errors;
      } else if (code == 1) {
        Dialog({
          title: i18n.t("error:errorMsg.requestFailTitle"),
          hideCancelBtn: true,
        });
        return "error";
      } else if (code == 2) {
        Dialog({
          title: i18n.t("error:errorMsg.systemErrorTitle"),
          hideCancelBtn: true,
          hideOkBtn: false,
        });
        return "error";
      } else if (code == 401 || code == 3) {
        Dialog({
          title: i18n.t("error:errorMsg.systemMessage"),
          content:i18n.t("error:errorMsg.tokenTimeOut"),
          oKBtnTxt:i18n.t("error:errorMsg.confirmBtn"),
          hideCancelBtn: true,
          hideOkBtn: false,
          onSuccess:goToHomePage
        });
        sessionStorage.removeItem(TOKEN);
        return "error";
      } else if (code == 4) {
        Dialog({
          title: i18n.t("error:errorMsg.dataErrorTitle"),
          hideCancelBtn: true,
        });
        return "error";
      } else if (code == 5) {
        if(errorMsg ==="LYS-SP01"){         
          return errorMsg;
        }else{          
          Dialog({ title: "Custom Error", hideCancelBtn: true });
          return "error";
        }

      } else {
        Dialog({
          title: i18n.t(
            "error:errorMsg.systemErrorTitle"
          )`, error Code:${errors[0].errorCode}`,
          hideCancelBtn: false,
        });
        return "error";
      }
    }
  },
  (err) => {
    console.log("err!!!!!!!!!!");
    hideLoading();
    const data = err || {};
    const errStatus = data.status;
    switch (errStatus) {
      case 3:
      case 401:
        Dialog({
          title: i18n.t("error:errorMsg.systemMessage"),
          content:i18n.t("error:errorMsg.tokenTimeOut"),
          oKBtnTxt:i18n.t("error:errorMsg.confirmBtn"),
          hideCancelBtn: true,
          hideOkBtn: false,
          onSuccess:goToHomePage
        });
        sessionStorage.removeItem(TOKEN);
        break;
      case 404:
        Dialog({ title: i18n.t("error:errorMsg.404"), hideCancelBtn: true });
        break;
      case 0:
        Dialog({ title: i18n.t("error:errorMsg.networkerror"), hideCancelBtn: true });
        break;
      case 1:
        Dialog({
          title: i18n.t("error:errorMsg.requestFailTitle"),
          hideCancelBtn: true,
        });
        break;
      case 2:
        break;
      default:
        Dialog({ title: data.message, hideCancelBtn: true });
        break;
    }
  }
);
export default fly;
